/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { Hint } from "react-autocomplete-hint";
import { useHits, useSearchBox } from "react-instantsearch";

const SearchBoxWithHint = ({
  isInNavbar,
  locale,
  query,
  onChangeQuery,
}: {
  isInNavbar: boolean;
  locale: Locales;
  query: string;
  onChangeQuery: (value: string) => void;
}) => {
  const { refine } = useSearchBox();
  const { hits } = useHits<any>();

  const [inputValue, setInputValue] = useState(query || "");
  const [hintOptions, setHintOptions] = useState<string[]>([]);

  useEffect(() => {
    setInputValue(query);
    refine(query);
  }, [query]);

  useEffect(() => {
    refine(inputValue);
    onChangeQuery?.(inputValue);
  }, [inputValue, refine, onChangeQuery]);

  useEffect(() => {
    const titles = hits.map((hit: any) => hit.title).filter(Boolean);
    setHintOptions(titles);
  }, [hits]);

  return (
    <Hint options={hintOptions} allowTabFill>
      <input
        id="search-input"
        type="search"
        autoComplete="off"
        spellCheck={false}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={isInNavbar ? __("Search for a product", locale) : __("Product, material", locale)}
        aria-label="Search for products"
        className={cn(
          "h-auto w-full border-0 p-3.5 shadow-none focus:outline-none focus-visible:ring-0",
          isInNavbar ? "pr-0 text-sm" : "pl-0 text-lg"
        )}
      />
    </Hint>
  );
};

export default SearchBoxWithHint;
